import type { Time } from "~/tools/date-time/time";
import type { Destructor } from "~/tools/destructor";
import { max } from "~/tools/max";

/**
 * Executes a callback function after a specified delay.
 *
 * @param callback - The callback function to be executed.
 * @param timeout - The delay in milliseconds before the callback is executed.
 *
 * @returns A cleanup function that can be used to cancel the timeout.
 */
export function onTimeout(callback: (now: Time) => void, timeout: number): Destructor {
	// biome-ignore lint/style/noRestrictedGlobals: encapsulation
	const timeoutId = window.setTimeout(() => callback(Date.now()), max(0, timeout));

	// biome-ignore lint/style/noRestrictedGlobals: encapsulation
	return () => window.clearTimeout(timeoutId);
}
